import React from 'react';
import '../css/header-footer.css';

const FooterComponent = () => {
    return (
        <div className='footer'>
            &copy; 2021 NightOwl Corp. - All rights reserved
        </div>
    );
}

export default FooterComponent;